<template>
    <div class="wrapper">
        <div v-if="docs != null">
          <div v-for="doc in docs" :key="doc.id">
            <div v-for="file in doc.FileToGroups" :key="file.id">
              <Button style="" class="mb-4 p-button-text" :label="file.name" @click="openDocument(file.objectId)" icon="pi pi-file" ></Button>
            </div>
          </div>
        </div>
    </div>
</template>

<script>
import Button from 'primevue/button'
export default {
  name: 'ConnectedDouments',
  components: {
    Button
  },
  data () {
    return {
      docs: []
    }
  },
  props: {
    groups: {
      type: Array
    }
  },
  created () {
  },
  async mounted () {
    await this.getDocuments(this.$props.groups)
  },
  watch: {
    groups: function (newVal, oldVal) {
      this.getDocuments(newVal)
    }
  },
  methods: {
    async getDocuments (groups) {
      groups.forEach(group => {
        var url = '/api/filegroups/' + group
        this.$http
          .get(url)
          .then(response => {
            this.docs.push(response.data)
          })
          .catch(error => console.log(error))
      })
    },
    async openDocument (id) {
      let response = await this.$http.get('/api/files/' + id)
      let downloadLink = document.createElement('a')
      downloadLink.href = response.data.url
      downloadLink.download = response.data.name
      downloadLink.target = 'blank'
      document.body.appendChild(downloadLink)
      downloadLink.click()
      document.body.removeChild(downloadLink)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Files/ConnectedDocuments.vue